<template>
	<div>
		<div class="VImg">
			<div class="videImg" v-for="(item,i) in videos">
				<video class="vide" controls="" :src="item.videoUrl"></video>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				videos: [
					{
						videoUrl:"https://video.melinked.com/2020/12/2bd342a1-7a4f-4a17-9511-f22a050178ce.mp4",
						href:"https://www.melinked.com/#/detail/pai_MzM3NDAwOTc2MTM5Nzk3MjY=",
						Imageurl:"../assets/img/2bd342a1-7a4f-4a17-9511-f22a050178ce.jpg",
						title:"我疯狂的5000美元中国之旅！_如何旅行2020.mp4"
					},
					{
						videoUrl:"https://video.melinked.com/2020/12/07fb2b57-ee60-4244-b197-6a43b43f5153.mp4",
						href:"https://www.melinked.com/#/detail/pai_MzM3NDAwOTc2MTM5Nzk3MjU=",
						Imageurl:"../assets/img/07fb2b57-ee60-4244-b197-6a43b43f5153.jpg",
						title:"周深竟然还会9门语言？外语能力也让我惊讶"
					},
					{
						videoUrl:"https://video.melinked.com/2020/12/c59687b0-d6c6-4649-8577-334be986e098.mp4",
						href:"https://www.melinked.com/#/detail/pai_MzM3NDAwOTc2MTM5Nzk3MjQ=",
						Imageurl:"../assets/img/c59687b0-d6c6-4649-8577-334be986e098.jpg",
						title:"西安-为什么你不需要兵马俑"
					},
					{
						videoUrl:"https://video.melinked.com/2020/12/81a34e4a-3af9-49bd-8327-17fb54a02cb4.mp4",
						href:"https://www.melinked.com/#/detail/pai_MzM3NDAwOTc2MTM5Nzk3MjM=",
						Imageurl:"../assets/img/81a34e4a-3af9-49bd-8327-17fb54a02cb4.jpg",
						title:"【美國家庭VS.台灣臭豆腐！】我的家人第一次嘗試臭豆腐+反應"
					},
					{
						videoUrl:"https://video.melinked.com/2020/12/630b712b-b49d-454a-be3e-2f84e32dd228.mp4",
						href:"https://www.melinked.com/#/detail/pai_MzM3NDAwOTc2MTM5Nzk3MDU=",
						Imageurl:"assets/img/630b712b-b49d-454a-be3e-2f84e32dd228.jpg",
						title:"视频2"
					},
					{
						videoUrl:"https://video.melinked.com/2020/12/ad570af0-c483-44d1-890e-58f4566446ce.mp4",
						href:"https://www.melinked.com/#/detail/pai_MzM3NDAwOTc2MTM5Nzk3MDQ=",
						Imageurl:"../assets/img/ad570af0-c483-44d1-890e-58f4566446ce.jpg",
						title:"视频"
					},
					{
						videoUrl:"https://video.melinked.com/2020/11/7fbe67da-cc6f-46d7-9730-5a3e93e0adfc.mp4",
						href:"https://www.melinked.com/#/detail/pai_MzM3NDAwOTc2MTM5Nzk2NjI=",
						Imageurl:"assets/img/7fbe67da-cc6f-46d7-9730-5a3e93e0adfc.jpg",
						title:"我们品尝了辛辣湘菜。。。。。撕开消化道系统.mp4"
					},
					{
						videoUrl:"https://video.melinked.com/2020/11/d2f8772d-9c15-4406-8899-1af1abe1f874.mp4",
						href:"https://www.melinked.com/#/detail/pai_MzM3NDAwOTc2MTM5Nzk2NjE=",
						Imageurl:"../assets/img/d2f8772d-9c15-4406-8899-1af1abe1f874.jpg",
						title:"我们第一次吃臭豆腐。。。。扰流板警报臭.mp4"
					},
					{
						videoUrl:"https://video.melinked.com/2020/11/775b6adf-1440-46c5-8dbe-7ec79779a9ec.mp4",
						href:"https://www.melinked.com/#/detail/pai_MzM3NDAwOTc2MTM5Nzk2NjA=",
						Imageurl:"assets/img/775b6adf-1440-46c5-8dbe-7ec79779a9ec.jpg",
						title:"我们试过松鼠鱼！它同样怪异美味..mp4"
					},
					{
						videoUrl:"https://video.melinked.com/2020/11/5d6153dc-ccbf-4a97-806b-8ba7e6aef624.mp4",
						href:"https://www.melinked.com/#/detail/pai_MzM3NDAwOTc2MTM5Nzk2NTk=",
						Imageurl:"../assets/img/5d6153dc-ccbf-4a97-806b-8ba7e6aef624.jpg",
						title:"探秘美国食物银行，美国真的很多人没饱饭吃吗？.mp4"
					},
				]
			}
		}
	}
</script>

<style scoped="scoped">
	.videImg{
	    position: relative;
	    width: 19%;
	    display: inline-block;
	    margin: 6px .4% ;
	}
	@media screen and (max-width: 800px){
		.videImg{
		    width: 100%;
				height: auto;
		}
	}
	.vide{
	    width: 100%;
	}
	.video{
	    width: 800px;
	    z-index: 999;
	}
	.open{
	    width: 100%;
	    height: 100%;
	    position: absolute;
	    top: 50%;
	    left: 50%;
	    transform: translate(-50%,-50%);
	    z-index: 999;
	    cursor: pointer;
	}
	.vs{
	    display: none;
	    height: 50px;
	}
	.videoS{
	    position: fixed;
	    top: 50%;
	    left: 50%;
	    transform: translate(-50%,-50%);
	    z-index: 9998;
	}
	.close{
	    position: fixed;
	    top: 1%;
	    right: 5%;
	    background-color: white;
	    z-index: 9999;
	    cursor: pointer;
	}
	.mid{
	    display: none;
	    position: fixed;
	    top: 0;
	    width: 100%;
	    height: 100%;
	    z-index: 999;
	    background-color: rgba(111,111,111,.9);
	}
</style>
